import ProfileEditorLayout from "../Components/Profile/ProfileEditorProvider";

const DesignerRoute = () => {
    return <ProfileEditorLayout user_type="designer"/>
};

export default DesignerRoute;
